import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ApiService } from '../../../core/services/api.service';
import { MessageService } from '../../../core/services/message.service';
import { DataTableComponent } from '../../../shared/data-table/data-table.component';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { Justification } from '../../../Models/justification';

@Component({
    selector: 'justifications',
    templateUrl: './justifications.component.html',
    styleUrls: ['./justifications.component.scss']
})

export class JustificationsComponent {
  @ViewChild("tableChild") tableChild: DataTableComponent<Justification>;
  pagePath: string = "api/ship/getJustifications";
  search: any;
  searchText: string = '';
  options = {
    columnTitles: ["JUSTIFICATIONS.TABLE.ID", "JUSTIFICATIONS.TABLE.DESCRIPTION", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'description', "actions"],
    actionButtons: { edit: true, delete: true }
  };
    constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

    }

goToEdit(e: any) {
    this.router.navigate(["justifications/edit", e.id]);
  }

openDeleteDialog(e: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '680px',
      data: {
        title: 'DIALOGS.DELETE_JUSTIFICATION.TITLE',
        body: 'DIALOGS.DELETE_JUSTIFICATION.BODY',
        cancelButtonText: "GENERAL.LABELS.CANCEL",
        confirmButtonText: "GENERAL.LABELS.DELETE",
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.apiService.delete('api/ship/justification/' + e.id).subscribe(data => {
          this.messageService.success("Exito", "La justificación fue removida exitosamente");
          this.tableChild.loadPage();
        }, error => {
          this.messageService.error("Error", error.message);
        })
      }
    });
  }

  searchJust(){
    this.search = {
      searchText: this.searchText
    }
    this.tableChild.firstPage();
    this.tableChild.loadPage(this.search);
  }
}
